
import { unlimitedLicenseArea } from "@/lib/constants";
import { Component, MixedVue } from "@/vue";
import { Prop } from "vue-property-decorator";

@Component({
  name: "LicenseDescription",
})
export default class LicenseDescription extends MixedVue {
  @Prop({ type: Number, required: false, default: 0 })
  userNr: number;

  @Prop({ type: Number, required: false, default: 0 })
  upperBound: number;

  unlimitedLicenseArea = unlimitedLicenseArea;
}
